import React, { useEffect } from "react";
import { IoFilter } from "react-icons/io5";
import { IoSettingsOutline } from "react-icons/io5";
import { IoMdAddCircle } from "react-icons/io";
import ProductCategoryList from "./partials/ProductCategoryList";
import AddProductCategory from "./partials/AddProductCategory";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import AxiosService from "../../services/AxiosHelper";
import { getCategoryList } from "../../redux/reducers/productSlice";
const baseURL = process.env.REACT_APP_BASEURL;

export default function ProductCategory() {
  return (  
    <div>
      <div className="mx-3 mt-4">
        <div className="container-fluid d-flex justify-content-between">
          <div className="row">
            <div className="col-12">
              <div className="pageTitle">
                <h1>Product Category</h1>
              </div>
            </div>
          </div>
          <div className="row align-right">
            <div className="col-12">
              <ul className="d-flex justify-content-center">
                {/* <li className="mx-2">
                  <a className="btn btn-filters">
                    {" "}
                    <IoFilter /> Filter
                  </a>
                </li> */}
                <li className="">
                  {" "}
                  <AddProductCategory type="add" />
                  {/* <IoMdAddCircle /> Add Category */}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <ProductCategoryList />
      </div>
    </div>
  );
}
